var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spnod-admin__form--container container px-0 mx-0 w-100 h-100"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2",
    attrs: {
      "name": "name",
      "state": _vm.validateState('name'),
      "type": "text",
      "placeholder": "Name",
      "size": "sm"
    },
    model: {
      value: (_vm.$v.form.name.$model),
      callback: function($$v) {
        _vm.$set(_vm.$v.form.name, "$model", $$v)
      },
      expression: "$v.form.name.$model"
    }
  }), _vm._v(" "), _c('b-form-textarea', {
    staticClass: "mb-4",
    attrs: {
      "name": "description",
      "state": _vm.validateState('description'),
      "type": "text",
      "rows": "3",
      "placeholder": "Description",
      "size": "sm"
    },
    model: {
      value: (_vm.$v.form.description.$model),
      callback: function($$v) {
        _vm.$set(_vm.$v.form.description, "$model", $$v)
      },
      expression: "$v.form.description.$model"
    }
  }), _vm._v(" "), _c('b-form-group', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "type": "submit",
      "disabled": _vm.isDisabled,
      "size": "sm"
    }
  }, [(!_vm.isSaving) ? _c('p', [_vm._v("Save")]) : _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b60866b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Forms/CreateGroupForm.vue
// module id = Cgke
// module chunks = 2